var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, CheckOutlined, ClockCircleOutlined, CloseOutlined, InfoCircleOutlined, PlusCircleOutlined, UnorderedListOutlined } from '@ant-design/icons';
import Drawer from 'components/AntEnhancement/Drawer';
import { plainToClass } from 'class-transformer';
import dayjs from 'dayjs';
import { useQueryClient } from 'react-query';
import { PatientJourney as PatientJourneyResource } from 'constants/resources';
import queries from 'constants/queries';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { PatientJourney } from 'models';
import services from 'services';
import { existingPatientJourneyId } from 'services/PatientJourneyService';
import '../../style.css';
var formatStartedAt = function (value) {
    if (!value)
        return null;
    var date = dayjs(value);
    if (!date.isValid())
        return null;
    if (date.isSame(dayjs(), 'day')) {
        return date.format('HH:mm');
    }
    if (date.isSame(dayjs().subtract(1, 'day'), 'day')) {
        return date.format('HH:mm');
    }
    return date.format('DD MMM YYYY');
};
var AddToJourneyDrawer = function (props) {
    var _a, _b;
    var t = props.translate, visiable = props.visiable, onCloseDrawer = props.onCloseDrawer, appointment = props.appointment, journeys = props.journeys, isLoading = props.isLoading, canCreateJourney = props.canCreateJourney;
    var navigate = useNavigate();
    var queryClient = useQueryClient();
    var patientJourneyService = services.patientJourneyService, permissionService = services.permissionService;
    var _c = useState(), existingJourneyId = _c[0], setExistingJourneyId = _c[1];
    var _d = patientJourneyService.useAppendStep(), appendStep = _d.mutateAsync, isAppending = _d.isLoading;
    var _e = patientJourneyService.useCreatePatientJourney(), createJourney = _e.mutateAsync, isCreating = _e.isLoading;
    var _f = useState(), selectedJourneyId = _f[0], setSelectedJourneyId = _f[1];
    var patient = (_a = appointment.getPatient) === null || _a === void 0 ? void 0 : _a.call(appointment);
    var patientName = ((_b = patient === null || patient === void 0 ? void 0 : patient.getName) === null || _b === void 0 ? void 0 : _b.call(patient)) || '—';
    var visitId = appointment.getId();
    var clinicId = appointment.getClinicId();
    var openJourneys = useMemo(function () {
        return (journeys || [])
            .filter(function (journey) { return !journey.isTerminal(); })
            .sort(function (left, right) {
            var leftHere = left.getClinicId() === clinicId ? 0 : 1;
            var rightHere = right.getClinicId() === clinicId ? 0 : 1;
            return leftHere - rightHere;
        });
    }, [journeys, clinicId]);
    useEffect(function () {
        if (visiable) {
            setExistingJourneyId(undefined);
            setSelectedJourneyId(undefined);
        }
    }, [visiable]);
    var appendAppointment = function (patientJourneyId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, appendStep({
                        patientJourneyId: patientJourneyId,
                        stepableType: 'Appointment',
                        stepableId: appointment.getId(),
                        stepKind: 'appointment',
                        successMessage: t('patientJourneys:messages.stepAppended')
                    })];
                case 1:
                    _a.sent();
                    queryClient.invalidateQueries(queries.appointments);
                    onCloseDrawer();
                    return [2 /*return*/];
            }
        });
    }); };
    var onAdd = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedJourneyId)
                        return [2 /*return*/];
                    return [4 /*yield*/, appendAppointment(selectedJourneyId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onCreateAndAdd = function () { return __awaiter(void 0, void 0, void 0, function () {
        var journey, response, created, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    journey = new PatientJourney();
                    journey.setPatientId(appointment.getPatientId());
                    journey.setClinicId(appointment.getClinicId());
                    setExistingJourneyId(undefined);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, createJourney({
                            patientJourney: journey,
                            successMessage: t('patientJourneys:messages.created')
                        })];
                case 2:
                    response = _a.sent();
                    created = plainToClass(PatientJourney, response.data);
                    return [4 /*yield*/, appendAppointment(created.getId())];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    setExistingJourneyId(existingPatientJourneyId(error_1));
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var statusTone = function (state) {
        if (state === 'in_progress')
            return 'is-progress';
        if (state === 'open')
            return 'is-open';
        return 'is-muted';
    };
    var stepsSummary = function (journey) {
        var _a;
        var steps = ((_a = journey.getSteps) === null || _a === void 0 ? void 0 : _a.call(journey)) || [];
        var done = steps.filter(function (step) { return step.getCurrentState() === 'done'; }).length;
        var active = steps.filter(function (step) { return step.getCurrentState() === 'active'; }).length;
        if (steps.length === 0) {
            return t('addToJourney.stepsCount', { count: 0 });
        }
        if (active > 0) {
            return t('addToJourney.stepsDetailWithActive', {
                count: steps.length,
                done: done,
                active: active
            });
        }
        if (done > 0) {
            return t('addToJourney.stepsDetail', {
                count: steps.length,
                done: done
            });
        }
        return t('addToJourney.stepsCount', { count: steps.length });
    };
    var startedLabel = function (journey) {
        var raw = journey.started_at;
        var formatted = formatStartedAt(raw);
        if (!formatted || !raw)
            return null;
        var date = dayjs(raw);
        if (date.isSame(dayjs(), 'day')) {
            return t('addToJourney.startedToday', { time: formatted });
        }
        if (date.isSame(dayjs().subtract(1, 'day'), 'day')) {
            return t('addToJourney.startedYesterday', { time: formatted });
        }
        return t('addToJourney.startedOn', { date: formatted });
    };
    var busy = isAppending || isCreating;
    var selectedCount = selectedJourneyId ? 1 : 0;
    return (_jsx(Drawer, { title: null, placement: "right", open: visiable, onClose: onCloseDrawer, closable: false, destroyOnClose: true, width: 640, rootClassName: "appointment-journey-drawer", className: "appointment-journey-drawer", "data-testid": "appointment-journey-drawer", children: _jsxs("div", { className: "appointment-journey-drawer__shell", children: [_jsxs("header", { className: "appointment-journey-drawer__header", children: [_jsxs("div", { className: "appointment-journey-drawer__title-row", children: [_jsxs("div", { className: "appointment-journey-drawer__title-block", children: [_jsx("button", { type: "button", className: "appointment-journey-drawer__icon-btn appointment-journey-drawer__icon-btn--bordered", onClick: onCloseDrawer, "aria-label": t('common:buttons.close'), children: _jsx(ArrowLeftOutlined, {}) }), _jsx("h2", { className: "appointment-journey-drawer__title", children: t('addToJourney.drawerTitle') }), _jsx("span", { className: "appointment-journey-drawer__badge", children: t('addToJourney.drawerBadge') })] }), _jsx("button", { type: "button", className: "appointment-journey-drawer__icon-btn", onClick: onCloseDrawer, "aria-label": t('common:buttons.close'), children: _jsx(CloseOutlined, {}) })] }), _jsxs("p", { className: "appointment-journey-drawer__subtitle", children: [t('addToJourney.drawerLead'), ' ', _jsx("span", { className: "appointment-journey-drawer__subtitle-em", children: t('addToJourney.visitLabel', { id: visitId }) }), ' ', t('addToJourney.drawerLeadFor'), ' ', _jsx("span", { className: "appointment-journey-drawer__subtitle-em", children: patientName }), ' ', t('addToJourney.drawerLeadTo')] })] }), _jsxs("div", { className: "appointment-journey-drawer__body", children: [existingJourneyId != null &&
                            permissionService.hasPermissionToShow(PatientJourneyResource) ? (_jsx("button", { type: "button", className: "appointment-journey-drawer__existing-link", onClick: function () { return navigate("/patient_journeys/".concat(existingJourneyId)); }, children: t('patientJourneys:errors.viewExisting', {
                                id: existingJourneyId
                            }) })) : null, _jsxs("div", { className: "appointment-journey-drawer__list-head", children: [_jsx("span", { className: "appointment-journey-drawer__section-label", children: t('addToJourney.listHeading', { count: openJourneys.length }) }), _jsx("span", { className: "appointment-journey-drawer__selected-count".concat(selectedCount > 0 ? ' is-active' : ''), children: t('addToJourney.selectedCount', { count: selectedCount }) })] }), isLoading ? (_jsx("div", { className: "appointment-journey-drawer__empty", children: t('addToJourney.loading') })) : openJourneys.length === 0 ? (_jsxs("div", { className: "appointment-journey-drawer__empty", children: [_jsx("p", { children: t('addToJourney.empty') }), canCreateJourney ? (_jsxs("button", { type: "button", className: "appointment-journey-drawer__create-btn", onClick: onCreateAndAdd, disabled: busy, "data-testid": "create-journey-submit", children: [_jsx(PlusCircleOutlined, {}), busy ? t('addToJourney.creating') : t('addToJourney.create')] })) : null] })) : (_jsx("div", { className: "appointment-journey-drawer__list", children: openJourneys.map(function (journey) {
                                var selected = selectedJourneyId === journey.getId();
                                var state = journey.getDisplayedState();
                                var sameClinic = journey.getClinicId() === clinicId;
                                var started = startedLabel(journey);
                                return (_jsxs("button", { type: "button", className: "appointment-journey-drawer__card".concat(selected ? ' is-selected' : ''), onClick: function () { return setSelectedJourneyId(journey.getId()); }, "data-testid": "journey-option-".concat(journey.getId()), children: [_jsxs("div", { className: "appointment-journey-drawer__card-top", children: [_jsxs("div", { className: "appointment-journey-drawer__card-main", children: [_jsx("span", { className: "appointment-journey-drawer__radio".concat(selected ? ' is-on' : ''), "aria-hidden": true, children: selected ? _jsx(CheckOutlined, {}) : null }), _jsx("span", { className: "appointment-journey-drawer__card-name", children: t('addToJourney.journeyId', {
                                                                id: journey.getId()
                                                            }) }), sameClinic ? (_jsx("span", { className: "appointment-journey-drawer__clinic-chip", children: t('addToJourney.thisClinic') })) : null] }), _jsxs("span", { className: "appointment-journey-drawer__status ".concat(statusTone(state)), children: [_jsx("span", { className: "appointment-journey-drawer__status-dot" }), t("patientJourneys:status.".concat(state))] })] }), _jsx("p", { className: "appointment-journey-drawer__card-clinic", children: journey.getClinicName() }), _jsxs("div", { className: "appointment-journey-drawer__card-foot", children: [_jsxs("span", { className: "appointment-journey-drawer__meta", children: [_jsx(UnorderedListOutlined, {}), stepsSummary(journey)] }), started ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "appointment-journey-drawer__meta-sep", children: "\u2022" }), _jsxs("span", { className: "appointment-journey-drawer__meta", children: [_jsx(ClockCircleOutlined, {}), started] })] })) : null] })] }, journey.getId()));
                            }) })), canCreateJourney && openJourneys.length > 0 ? (_jsxs("button", { type: "button", className: "appointment-journey-drawer__create-link", onClick: onCreateAndAdd, disabled: busy, "data-testid": "create-journey-submit", children: [_jsx(PlusCircleOutlined, {}), busy ? t('addToJourney.creating') : t('addToJourney.create')] })) : null, _jsxs("div", { className: "appointment-journey-drawer__note", children: [_jsx(InfoCircleOutlined, {}), _jsx("p", { children: t('addToJourney.noteBody') })] })] }), _jsxs("footer", { className: "appointment-journey-drawer__footer", children: [_jsx("button", { type: "button", className: "appointment-journey-drawer__btn appointment-journey-drawer__btn--ghost", onClick: onCloseDrawer, children: t('common:buttons.cancel') }), _jsxs("button", { type: "button", className: "appointment-journey-drawer__btn appointment-journey-drawer__btn--primary", onClick: onAdd, disabled: !selectedJourneyId || busy, "data-testid": "add-to-journey-submit", children: [_jsx(CheckOutlined, {}), _jsx("span", { children: isAppending
                                        ? t('addToJourney.adding')
                                        : t('addToJourney.confirm') })] })] })] }) }));
};
export default localeTranslator(AddToJourneyDrawer, 'showVisit');
